module.exports = __webpack_public_path__ + "02a16f333918f467fb518efd2726e187.svg";